// import { Select } from 'antd'
import HSelect from "../../../components/custom/input/select/Select";
import React from "react";
import UploadDragger from "./UploadDragger";
import { message } from "antd";
import { allowedExtensions } from "../../utils/VoiceUtils";

const VoiceSelect = (prop) => {
  const {
    data,
    setData,
    value,
    textAreaValue,
    setTextAreaValue,
    onChange,
    options,
    loading,
    fileName,
    textToSpeech,
    setTextToSpeech,
    url,
    setUrl,
    customClass,
    optionSpecification,
    label,
    placeholder,
  } = prop;
  const handleTextToSpeech = (e) => {
    setTextAreaValue(e.target.value);
  };
  const handleUrlUpdate = (e) => {
    setUrl(e.target.value);
    if (setTextToSpeech) {
      setTextToSpeech("");
    }
  };

  const props = {
    name: "file",
    multiple: false,
    accept: ".mp3,.wav,.aiff,.aif,.gsm,.ulaw",
    onChange(info) {
      if (info) {
        const fileExtension = info.file.name.split(".").pop().toLowerCase();
        if (allowedExtensions.includes(fileExtension)) {
          setData({
            ...data,
            fileName: info.file.name,
            file: info.file.originFileObj,
          });
        } else {
          message.error("Unsupported file type. Upload MP3, WAV, AIFF, or GSM audio files only.");
        }
      }
    },
    onDrop(e) {
      const droppedFile = e.dataTransfer.files[0];
      if (droppedFile) {
        const fileExtension = droppedFile.name.split(".").pop().toLowerCase();
        if (allowedExtensions.includes(fileExtension)) {
          setData({
            ...data,
            fileName: droppedFile.name,
            file: droppedFile,
          });
        } else {
          message.error("Unsupported file type. Upload MP3, WAV, AIFF, or GSM audio files only.");
        }
      }
    },
  };

  return (
    <div className="voiceSelect w-100">
      <HSelect
        label={label}
        customProps={{
          onSelect: onChange,
          value: value,
          className: customClass,
        }}
        placeholder={`${placeholder || ""}`}
        defaultValue={value}
        options={options}
        enableSearch={false}
        // customProps={{
        //     className: "music-type-select typesOfPlayAudio",
        // }}
        suffixIcon={<div className="call-action-icons callDropdownIcon" />}
        onChange={onChange}
      />

      {optionSpecification &&
        (value === "textToSpeech" ? (
          <div className="mt-4">
            <label className="hs-fs-14">Text</label>
            <br />
            <textarea className="speechTextArea" placeholder="Text goes here" onChange={handleTextToSpeech} value={textAreaValue}></textarea>
          </div>
        ) : value === "playAudio" ? (
          <div className="mt-4">
            <label className="hs-fs-14">Upload Music</label>
            <UploadDragger props={props} loading={loading} fileName={fileName} />
          </div>
        ) : value === "url" ? (
          <div className="mt-4">
            <label className="hs-fs-14">Link</label>
            <br />
            <textarea className="speechTextArea" placeholder="Paste the link" onChange={handleUrlUpdate} value={url}></textarea>
          </div>
        ) : (
          ""
        ))}
    </div>
  );
};

export default VoiceSelect;
